import { onLCP, onFID, onCLS, onINP } from 'web-vitals';
import apiService from 'src/services/api-service';
// import { getShop } from 'src/helpers';

const Action = {
  LARGEST_CONTENTFUL_PAINT: 'APP::WEB_VITALS::LARGEST_CONTENTFUL_PAINT',
  FIRST_INPUT_DELAY: 'APP::WEB_VITALS::FIRST_INPUT_DELAY',
  CUMULATIVE_LAYOUT_SHIFT: 'APP::WEB_VITALS::CUMULATIVE_LAYOUT_SHIFT',
  FIRST_CONTENTFUL_PAINT: 'APP::WEB_VITALS::FIRST_CONTENTFUL_PAINT',
  TIME_TO_FIRST_BYTE: 'APP::WEB_VITALS::TIME_TO_FIRST_BYTE',
  INTERACTION_TO_NEXT_PAINT: 'APP::WEB_VITALS::INTERACTION_TO_NEXT_PAINT'
};

function actionWrapper(action) {
  return {
    ...action,
    route: window.location.pathname
  };
}

function largestContentfulPaint(payload) {
  return actionWrapper({
    type: Action.LARGEST_CONTENTFUL_PAINT,
    payload: payload
  });
}

function firstInputDelay(payload) {
  return actionWrapper({
    type: Action.FIRST_INPUT_DELAY,
    payload: payload
  });
}

function cumulativeLayoutShift(payload) {
  return actionWrapper({
    type: Action.CUMULATIVE_LAYOUT_SHIFT,
    payload: payload
  });
}

// function firstContentfulPaint(payload) {
//   return actionWrapper({
//     type: Action.FIRST_CONTENTFUL_PAINT,
//     payload: payload
//   });
// }

// function timeToFirstByte(payload) {
//   return actionWrapper({
//     type: Action.TIME_TO_FIRST_BYTE,
//     payload: payload
//   });
// }

function interactionToNextPaint(payload) {
  return actionWrapper({
    type: Action.INTERACTION_TO_NEXT_PAINT,
    payload: payload
  });
}

function initializeWebVitals() {
  function onReport(cb) {
    return function (data) {
      var id = data.id,
        metricName = data.name,
        value = data.value;
      var payload = { id: id, metricName: metricName, value: value };
      var event = cb(payload);
      const request = apiService.buildRequestPayload('admin-v3.web-vitals.save-log', {});
      // const tenantId = getShop();
      // if (tenantId.startsWith('bc-dev')) {
      //   console.log('internal vitals report::', event)
      // }
      fetch(request.endpoint, {
        headers: request.headers,
        method: request.method,
        body: JSON.stringify(event)
      });
    };
  }
  var untypedWindow = window;
  if (untypedWindow.__boost_is_web_vitals_initialized__) {
    // We need to prevent the Web Vitals functions from being called more than once per page load,
    // which can cause a memory leak as per the web-vitals docs.
    return;
  }
  untypedWindow.__boost_is_web_vitals_initialized__ = true;
  onLCP(onReport(largestContentfulPaint));
  onFID(onReport(firstInputDelay));
  onCLS(onReport(cumulativeLayoutShift));
  // onFCP(onReport(firstContentfulPaint));
  // onTTFB(onReport(timeToFirstByte));
  onINP(onReport(interactionToNextPaint));
}

export default initializeWebVitals;
